export const propertiesHeaders = [
  { content: "" },
  { content: "Property" },
  { content: "Inncode", isSorting: true },
  { content: "Brand" },
  { content: "*All Plans", isSorting: true },
  { content: "Brand Deadlines & Initiatives" },
  { content: "Property Engagement" }
];

export const dashboardPropertiesHeaders = [
  { content: "" },
  { content: "Property" },
  { content: "Inncode", isSorting: true },
  { content: "Brand" },
  { content: "*Plans", isSorting: true, ignoreTooltip: true },
  { content: "Mgmt. Co" },
  { content: "Owner Group" },
  { content: "Property Engagement", isSorting: true }
];

export const plansHeaders = [
  { content: "" },
  { content: "Plan", isSorting: true },
  { content: "Functional Area" },
  { content: "Plan Source" },
  { content: "Properties", isSorting: true },
  { content: "Status" }
];

export const templatePlansHeaders = [
  { content: "" },
  { content: "Plan", isSorting: true },
  { content: "Functional Area" },
  { content: "Assignments", isSorting: true },
  { content: "Status" }
];

export const dashboardTemplatePlansHeaders = [
  { content: "" },
  { content: "Plan", isSorting: true },
  { content: "Functional Area" },
  { content: "Properties", isSorting: true }
];

export const dashboardPlansHeaders = [
  { content: "" },
  { content: "Plan", isSorting: true },
  { content: "Functional Area" },
  { content: "Plan Source" },
  { content: "Properties", isSorting: true }
];

export const plansHeadersSC = [
  { content: "" },
  { content: "Plan", isSorting: true },
  { content: "Functional Area" },
  { content: "Plan Source" },
  { content: "Assignments", isSorting: true },
  { content: "Status" }
];

export const scPropertiesHeaders = [
  { content: "" },
  { content: "Property", isCheckBox: true },
  { content: "Inncode", isSorting: true },
  { content: "User" },
  { content: "Brand" },
  { content: "Plans", isSorting: true },
  { content: "" }
];
